import { useState } from 'react';
import { useInstallPrompt } from '../../installer/pwa/useInstallPrompt';

const DISMISS_KEY = 'installer_install_dismissed';
const bar = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10,
  margin: '0 0 12px', padding: '10px 12px', borderRadius: 12,
  background: '#f0fdfa', border: '1px solid #99f6e4', color: '#0f766e',
  fontSize: 12.5, fontWeight: 600,
};
const cta = {
  background: '#0d9488', color: '#fff', border: 'none', borderRadius: 8,
  padding: '7px 14px', fontWeight: 700, cursor: 'pointer', font: 'inherit',
};

export default function InstallBanner() {
  const { canInstall, installed, isIos, promptInstall } = useInstallPrompt();
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(DISMISS_KEY) === '1');

  if (installed || dismissed) return null;
  if (!canInstall && !isIos) return null;

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, '1'); setDismissed(true); };

  return (
    <div style={bar}>
      {canInstall ? (
        <button style={cta} onClick={promptInstall}>افزودن به صفحه‌ی اصلی</button>
      ) : (
        <span>برای نصب: «اشتراک‌گذاری» سپس «افزودن به صفحه‌ی اصلی»</span>
      )}
      <button aria-label="بستن" onClick={dismiss}
        style={{ background: 'transparent', border: 'none', color: '#0f766e', fontSize: 18, cursor: 'pointer' }}>×</button>
    </div>
  );
}
